import * as React from 'react'

const BaseUri = '/static/assets/hero-screen/'
const codeSnippetIconBase =  BaseUri + 'code-snippets-icons/'
const iconHighlighterImage = codeSnippetIconBase + '7.png'
const iconMain = codeSnippetIconBase + '6.png'
const codeSnippet = BaseUri + 'code-snippets/' + '6.png'
const codeSnippetMobile = BaseUri + 'code-snippets/' + 'mobile/6.png'
import "./../../style/code-snippet-container-module.css"
import "./../../style/common.module.css"

const KeyFeature = () => {
    const codeContextDistance = <span className="code-snippet-context-distance"></span>
    const codeSnippetMobileTabletMargins = <span className="code-snippet-tablet-mobile-margin"></span>
    return(
    <>
    {/* Desktop and Tablet Version*/}
    <div className="d-none d-lg-block">
        <div className="key-feature-primary hero-code-snippets-margins flex-wrap">
            <div className='row-custom'>
            {codeContextDistance}
            {codeSnippetMobileTabletMargins}
            <div className="code-snippet-textual-part-width">
            <div className="key-feature-highlighter">
                <div className="row-custom">
                    <span className="key-feature-para-margins tiny-text bold">Key Feature</span>
                    <img src={iconHighlighterImage} className="key-feature-icon-height" />
                </div>
            </div>
                <img src={iconMain} className="key-feature-icon-main" />
                <h1 className="primary-heading-font-size code-snippet-common-margin bold"> Detect token theft</h1>
                <div className="row-custom">
                    <span className="code-snippet-primary-dash">-</span>
                    <p> SuperTokens is the only solution that is able to reliably detect session hijacking via rotating refresh tokens</p>
                </div>
            </div>
            {codeContextDistance}
            </div>
            <div className="row-custom">
                {codeContextDistance}
                <img src={codeSnippet} className='code-snippet-image-key'/>
            </div>
        </div>
    </div>
    {/* Tablet and Mobile */}
    <div className='d-block d-lg-none'>
        <div className="key-feature-primary-mobile-desktop hero-code-snippets-margins">
        <div className="key-feature-highlighter">
             <div className="row-custom">
                    <span className="key-feature-para-margins tiny-text bold">Key Feature</span>
                    <img src={iconHighlighterImage} className="key-feature-icon-height-mobile" />
            </div>
        </div>
            <img src={iconMain} className="key-feature-icon-main" />
                <h1 className="primary-heading-font-size code-snippet-common-margin bold"> Detect token theft</h1>
                <div className="row-custom">
                    <span className="code-snippet-primary-dash">-</span>
                    <p> SuperTokens is the only solution that is able to reliably detect session hijacking via rotating refresh tokens</p>
                </div>
        </div>
        {/* Mobile Image */}
        <div className='d-block d-sm-none'>
            <img src={codeSnippetMobile} className='code-snippet-image-key'/>
        </div>
        <div className="d-none d-sm-block d-lg-none">
            <img src={codeSnippet} className='code-snippet-image-key'/>
        </div>
    </div>
    </>
    )
}



export default KeyFeature